/* @ngInject */
function AllTasksTabController ($scope, $rootScope, $translate, $timeout, $q, TasksService, ToastService, WorkflowHeaderService, UserFilterService, UdsModalService, ConfirmationModalService) {
  const getSaveTaskFilterDialogController = () => $q.when(import('../../dialogs/save-task-filter/save-task-filter-dialog.controller'))

  $scope.options = {
    $sort: 'createdAt',
    $order: 'DESC',
    $top: 10,
    $skip: 0,
    defaultStatus: ['INBOX', 'PROGRESS', 'REVIEW', 'WAITING_ADM_ADJUST', 'DONE']
  }

  $scope.items = []
  $scope.count = null

  $scope.loading = true
  $scope.loadingMore = false

  $scope.selectedQuickFilter = null
  $scope.selectedFilters = {}

  $scope.userFilters = []

  let loadingTasks = true

  const api = {
    getSaveTaskFilterDialogController,
    _getAllTasks,
    _resetTabObject,
    _getFilters,
    _getUserFilters,
    _getSelectedFilters,
    _getSelectedUserFilters,
    _openEditUserFilterDialog,
    _openDeleteUserFilterDialog,
    _clearAdvancedFilters,
    _setIsFiltering
  }
  this.getApi = () => api

  $translate.onReady(() => {
    $scope.sortOptions = [
      {
        label: $translate.instant('recents'),
        value: 'createdAt',
        active: true
      },
      {
        label: $translate.instant('status'),
        value: 'status'
      },
      {
        label: $translate.instant('title'),
        value: 'title'
      },
      {
        label: $translate.instant('priorityFilter'),
        value: 'tasks.priority'
      },
      {
        label: $translate.instant('deliveryDate'),
        value: 'tasks.deliveryDate'
      }
    ]

    $scope.quickFilter = {
      label: $translate.instant('myTasks'),
      value: 'MY_TASKS'
    }

    $scope.userFilterOptions = [
      {
        id: 'EDIT',
        label: $translate.instant('edit'),
        value: 'EDIT',
        active: false
      },
      {
        id: 'DELETE',
        label: $translate.instant('delete'),
        value: 'DELETE',
        active: false
      }
    ]
  })

  activate()

  function activate () {
    $scope.filters = WorkflowHeaderService.getAllTasksFilters($translate, $rootScope.oUser.locale)
    api._getUserFilters()
  }

  $scope.$watch('isTabSelected', (newVal) => {
    if (newVal && !loadingTasks && !$scope.loading) {
      api._resetTabObject()
      api._getAllTasks()
    }
  })

  $scope.onChangeSortOrder = () => {
    const sort = $scope.options.$sort
    const order = $scope.options.$order === 'ASC' ? 'DESC' : 'ASC'

    api._resetTabObject()

    $scope.options.$sort = sort
    $scope.options.$order = order

    api._getAllTasks()
  }

  $scope.onChangeSortSelect = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value) {
      api._resetTabObject()

      $scope.options.$sort = value

      api._getAllTasks()
    }
  }

  $scope.loadMoreAllTasks = async () => {
    try {
      $scope.loadingMore = true
      $scope.options.$skip = $scope.options.$skip + $scope.options.$top
      api._getAllTasks()
    } catch (error) {
      ToastService.defaultErrorToast()
    } finally {
      $scope.loadingMore = false
    }
  }

  $scope.onQuickFilterClick = (value) => {
    if (value === $scope.selectedQuickFilter) {
      $scope.selectedQuickFilter = null
    } else {
      $scope.selectedQuickFilter = value
    }

    $('.filters-section uds-pill-select').attr('checked', false)

    api._clearAdvancedFilters()
    api._resetTabObject()
    api._getAllTasks()
  }

  $scope.onFilter = (filters, hasPreFilters, filtersCount, ignoreSubmit) => {
    if (loadingTasks) {
      loadingTasks = false
      return
    }

    $scope.selectedFilters = filters
    if (ignoreSubmit) return

    $scope.selectedQuickFilter = null

    $('.filters-section uds-pill-select').attr('checked', false)

    api._resetTabObject()
    api._getAllTasks()
  }

  $scope.onSaveFilter = (filters) => {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: filters,
          allFilters: $scope.filters,
          location: 'all-tasks'
        },
        onClose: (wasCreated) => {
          if (wasCreated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  $scope.onUserFilterSelect = (event, userFilter) => {
    if (event.detail?.checked) {
      $scope.selectedQuickFilter = userFilter
    } else {
      $scope.selectedQuickFilter = null
    }

    $(`uds-pill-select:not(.user-filter-${userFilter.id})`).attr('checked', false)

    api._clearAdvancedFilters()
    api._resetTabObject()
    api._getAllTasks()
  }

  $scope.onUserFilterOptionClick = (event, userFilter) => {
    const option = event.detail?.option?.value

    if (option === 'EDIT') {
      api._openEditUserFilterDialog(userFilter)
    } else if (option === 'DELETE') {
      api._openDeleteUserFilterDialog(userFilter)
    }
  }

  function _getAllTasks () {
    $scope.loading = true

    const filters = api._getFilters()

    api._setIsFiltering(filters)

    return TasksService.getTasks({
      $top: $scope.options.$top,
      $skip: $scope.options.$skip,
      $sort: $scope.options.$sort,
      $order: $scope.options.$order,
      ...filters
    }).then(result => {
      $scope.items.push(...result.rows)
      $scope.count = result.count
      $scope.tabCount = result.count
    }).finally(() => {
      $timeout(() => { $scope.loading = false })
    })
  }

  function _resetTabObject () {
    $scope.loading = false
    $scope.loadingMore = false
    $scope.items = []
    $scope.count = null
    $scope.options.$top = 10
    $scope.options.$skip = 0
    $scope.options.$sort = 'createdAt'
    $scope.options.$order = 'DESC'
  }

  function _getFilters () {
    if ($scope.selectedQuickFilter?.userId) {
      return api._getSelectedUserFilters()
    } else {
      return api._getSelectedFilters()
    }
  }

  function _getSelectedFilters () {
    if ($scope.selectedQuickFilter === 'MY_TASKS') {
      return {
        assignees: [$rootScope.oUser.id],
        isArchived: false
      }
    }

    const filters = {
      taskStatus: $scope.selectedFilters?.status || [],
      taskTypes: $scope.selectedFilters?.type || [],
      taskTags: $scope.selectedFilters?.tags || [],
      assignees: $scope.selectedFilters?.assignees || [],
      priorities: $scope.selectedFilters?.priorities || [],
      authors: $scope.selectedFilters?.authors || [],
      deliveryDateStart: $scope.selectedFilters?.deliveryDateStart,
      deliveryDateEnd: $scope.selectedFilters?.deliveryDateEnd,
      isArchived: $scope.selectedFilters?.isArchived,
      form: $scope.selectedFilters?.form || [],
      createdAtStart: $scope.selectedFilters?.createdAtStart,
      createdAtEnd: $scope.selectedFilters?.createdAtEnd,
      daysInStage: $scope.selectedFilters?.daysInStage,
      groups: $scope.selectedFilters?.groups || []
    }

    if (!filters.taskStatus.length) {
      filters.taskStatus = $scope.options.defaultStatus
    }

    return filters
  }

  function _getSelectedUserFilters () {
    const filterObj = {}

    $scope.selectedQuickFilter.filterItems.forEach(item => {
      filterObj[item.filter] = item.value
    })

    const filters = {
      taskStatus: filterObj.status || [],
      taskTypes: filterObj.type || [],
      taskTags: filterObj.tags || [],
      assignees: filterObj.assignees || [],
      priorities: filterObj.priorities || [],
      authors: filterObj.authors || [],
      deliveryDateStart: filterObj.deliveryDateStart,
      deliveryDateEnd: filterObj.deliveryDateEnd,
      isArchived: filterObj.isArchived,
      form: filterObj.form || [],
      createdAtStart: filterObj.createdAtStart,
      createdAtEnd: filterObj.createdAtEnd,
      daysInStage: filterObj.daysInStage,
      groups: filterObj.groups || []
    }

    if (!filters.taskStatus.length) {
      filters.taskStatus = $scope.options.defaultStatus
    }

    return filters
  }

  function _getUserFilters () {
    UserFilterService.getUserFilters('all-tasks').then(filters => {
      $scope.userFilters = filters

      if ($scope.userFilters.length) {
        $scope.selectedQuickFilter = $scope.userFilters[0]

        const waitForElement = () => {
          const element = $(`uds-pill-select.user-filter-${$scope.selectedQuickFilter.id}`)
          if (element.length > 0) {
            element.attr('checked', true)
            api._resetTabObject()
            api._getAllTasks()
          } else {
            $timeout(waitForElement, 100)
          }
        }

        $scope.$evalAsync(waitForElement)
      } else {
        api._resetTabObject()
        loadingTasks = false
        api._getAllTasks()
      }
    })
  }

  function _openEditUserFilterDialog (userFilter) {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: userFilter.filterItems,
          allFilters: $scope.filters,
          editMode: true,
          name: userFilter.name,
          userFilterId: userFilter.id
        },
        onClose: (wasUpdated) => {
          if (wasUpdated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  function _openDeleteUserFilterDialog (userFilter) {
    ConfirmationModalService.createModal({
      title: $translate.instant('deleteFilter.title'),
      description: $translate.instant('deleteFilter.description', { filterName: userFilter.name }),
      buttonCancelText: $translate.instant('no'),
      buttonConfirmText: $translate.instant('yesDelete'),
      onConfirm: () => {
        UserFilterService.deleteUserFilter(userFilter.id)
          .then(() => {
            api._getUserFilters()
            ToastService.showSuccessToast($translate.instant('deleteFilter.success', { filterName: userFilter.name }))
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }

  function _clearAdvancedFilters () {
    $scope.$broadcast('advancedSearch.clearAllFilters', true)
  }

  function _setIsFiltering (filters) {
    const filteringActives = filters.isArchived === 'false' || filters.isArchived === false
    const filtersWithValue = UserFilterService.getFiltersWithValue(filters)
    const onlyOneFilter = filtersWithValue.length === 1
    const twoFilters = filtersWithValue.length === 2
    $scope.isFiltering = !(onlyOneFilter || (twoFilters && filteringActives))
  }
}

export { AllTasksTabController }
